var map = {
	"./absa.scss": [
		5597,
		597
	],
	"./appletree.scss": [
		15366,
		366
	],
	"./aunipay.scss": [
		73305,
		305
	],
	"./awalletPaymentplug.scss": [
		11414,
		414
	],
	"./default.scss": [
		12539,
		539
	],
	"./dreamzwallet.scss": [
		536,
		536
	],
	"./lMAnimation.scss": [
		73725,
		725
	],
	"./mego.scss": [
		72314,
		314
	],
	"./onetap.scss": [
		83223,
		223
	],
	"./takapaysa.scss": [
		11737,
		737
	],
	"./theme_1.scss": [
		49331,
		331
	],
	"./transactWorldUK.scss": [
		86228,
		228
	],
	"./unipay.scss": [
		70374,
		374
	],
	"./walletz.scss": [
		50611,
		611
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52118;
module.exports = webpackAsyncContext;